import React from 'react';

const BlazeTableActions = (props: any) => {
  return <div className={'flex-table-actions'}>{props.children}</div>;
};

export default BlazeTableActions;
